import _ from 'underscore';
import xtend from 'xtend';

import Store from '../../lib/store/store-v2';

export default function VastListStore (apiBus) {

    var state = Store();

    const key = 'campaignID';

    var apiActions = Store.ApiActions(state, key, {
        delete: function (response) {
            if (response.data && state.data().hasOwnProperty(response.data[key])) {
                var temp = state.data();
                delete temp[response.data[key]];
                state.set({
                    data: temp,
                    isResolving: false
                });
            }
        }
    });

    Store.SubscribeToApi(apiActions, apiBus);

    return {
        state: Store.Parse(state, function (data) {
            var asArray = _.toArray(data.data);
            return (xtend(data, { data: _(asArray).sortBy('name') }));
        })
    };
};
